export const HOME = `/`;
export const STEPONE = `/step-one`;
export const STEPTWO = `/step-two`;
export const STEPTHREE = `/step-three`;
export const STEPFOUR = `/step-four`;
export const STEPFIVE = `/step-five`;
export const STEPSIX = `/step-six`;
export const STEPSEVEN = `/step-seven`;
export const STEPEIGHT = `/step-eight`;
export const STEPNINE = `/step-nine`;
export const SUMMARY = `/summary`;
export const ASSESSMENT = `/assessment`;
export const SCHEDULE = `/schedule`;
export const CONTACT = `/contact`;
export const CONTACTEMAIL = `/contact-email`;
export const CONTACTCOACH = `/contact-coach`;
export const THANKYOU = `/thank-you`;
export const THANKYOUEMAIL = `/thank-you-email`;
export const THANKYOUCOACH = `/thank-you-coach`;
